import { FC, ReactNode } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { ApplicationState, CommanderThunkDispatch } from '@mews-commander/types';
import { BulkCheckbox, SpacingMediumLeft } from '@mews-commander/ui';
import { withScopeContext } from '@mews/framework';
import {
    areAllBillItemsSelected,
    areSomeBillItemsSelected,
    isBillEmpty,
    toggleBillItemsSelect,
} from '../../ducks/billItems';

interface StateProps {
    allSelected: boolean;
    someSelected: boolean;
    billEmpty: boolean;
}

interface DispatchProps {
    toggle(): void;
}

interface OwnProps {
    billId: string;
    scope: string;
    children?: ReactNode;
    'data-test-id'?: string;
}

type SelectAllCheckboxProps = StateProps & DispatchProps & OwnProps;

const SelectAllCheckbox: FC<SelectAllCheckboxProps> = ({
    allSelected,
    toggle,
    billEmpty,
    billId,
    someSelected,
    children,
    'data-test-id': dataTestId,
}) => (
    <SpacingMediumLeft>
        {billEmpty ? null : (
            <BulkCheckbox
                allSelected={allSelected}
                data-test-id={dataTestId}
                data-select-all-checkbox={billId}
                onChange={toggle}
                someSelected={someSelected}
            >
                {children}
            </BulkCheckbox>
        )}
    </SpacingMediumLeft>
);

export default withScopeContext(
    connect<StateProps, DispatchProps, OwnProps, ApplicationState>(
        createStructuredSelector({
            allSelected: areAllBillItemsSelected,
            billEmpty: isBillEmpty,
            someSelected: areSomeBillItemsSelected,
        }),
        (dispatch: CommanderThunkDispatch, { billId, scope }) => ({
            toggle: () => dispatch(toggleBillItemsSelect(billId, scope)),
        })
    )(SelectAllCheckbox)
);
